'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gapi = require('gapi');

var _gapi2 = _interopRequireDefault(_gapi);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _login = require('ifeis-isomorphic/lib/redux/actions/login');

var _getFeatureFlags = require('ifeis-isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginController = function () {
  function LoginController($q, fSession, config, msgService, $ngRedux) {
    _classCallCheck(this, LoginController);

    this._ = { fSession: fSession, $q: $q, msgService: msgService, $ngRedux: $ngRedux };
    this.config = config;

    this.cognito = {
      username: '',
      password: '',
      email: '',
      firstName: '',
      lastName: '',
      confirmationCode: '',
      resetCode: '',
      newPassword: ''
    };

    this.signup = false;
    this.showConfirmation = false;
    this.showResetPassword = false;
    this.showResetCode = false;

    this.loginProviders = [{ name: 'Google', slug: 'google', signin: this._google.bind(this) }, { name: 'Facebook', slug: 'facebook-square', signin: this._facebook.bind(this) }, { name: 'Cognito', slug: 'cognito', signin: this._cognito.bind(this), forgotPassword: this.forgotPassword.bind(this) }];

    this._gapi = $q(function (resolve) {
      return _gapi2.default.load('auth2', function () {
        return resolve();
      });
    }).then(function () {
      var auth2 = _gapi2.default.auth2.init({
        client_id: GOOGLE_CLIENT_ID,
        approval_prompt: 'auto',
        scope: 'email profile'
      });

      // Stupid Hack: the object returned has a `then` function that is never called, mucking with
      // the promise, so we just wrap it in an object instead.
      return { auth2: auth2 };
    });
  }

  _createClass(LoginController, [{
    key: 'updateResetProps',
    value: function updateResetProps() {
      this.showResetPassword = false;
      this.showResetCode = false;
    }
  }, {
    key: '_facebook',
    value: function _facebook() {
      var _this = this;

      var ifLoggedIn = function ifLoggedIn(response) {
        return _this._.$q(function (res, rej) {
          if (response.status === 'connected') {
            _this._logIn('facebook', response.authResponse.accessToken);
            res();
          } else {
            rej(response);
          }
        });
      };

      FB.getLoginStatus(function (response) {
        return ifLoggedIn(response).catch(function () {
          return FB.login(function (response) {
            return ifLoggedIn(response);
          }, { scope: 'public_profile,email' });
        }).catch(function (res) {
          return console.log('Could not log in the user.', res);
        });
      });
    }
  }, {
    key: '_google',
    value: function _google() {
      var _this2 = this;

      this._gapi.then(function (_ref) {
        var auth2 = _ref.auth2;
        return auth2.signIn();
      }).then(function (response) {
        return response.getAuthResponse();
      }).then(function (response) {
        return response.id_token;
      }).then(function (token) {
        return _this2._logIn('google', token);
      });
    }
  }, {
    key: '_cognito',
    value: function _cognito() {
      var _this3 = this;

      this.cognito.username = this.cognito.email;
      if (this.signup) {
        if (this.showConfirmation) {
          return this._confirmSignup();
        }
        return this._signUpWithCognito('cognito');
      } else {
        return this._logIn('cognito').then(function (response) {
          if (response && !response.payload) {
            _this3._.msgService.displayErrorMsg('iFeis login failed. Reason: ' + (response.errors && response.errors.data && response.errors.data.message || 'Please check your username and password.'));
          }
        });
      }
    }
  }, {
    key: '_signUpWithCognito',
    value: function _signUpWithCognito(provider) {
      var _this4 = this;

      if (provider === 'cognito') {
        return this._.$ngRedux.dispatch((0, _login.registerWithCognito)(this.cognito.username, this.cognito.password, this.cognito.email, this.cognito.firstName, this.cognito.lastName)).then(function (response) {
          if (!response.payload) {
            var errorMessage = response.errors && response.errors.data && response.errors.data.message || undefined;
            if (errorMessage && errorMessage.includes('UsernameExistsException')) {
              _this4._.msgService.displayErrorMsg('Signup failed. An account with this email already exists, please login.');
            } else {
              _this4._.msgService.displayErrorMsg('Signup failed. ' + (response.errors && response.errors.data && response.errors.data.message || '. It could be that you already have an account with this email address. Please contact support to check'));
            }
          } else {
            _this4.showConfirmation = true;
            _this4._.msgService.displaySuccessMsg('Please check your email for confirmation code.');
          }
        }).catch(function (err) {
          throw err;
        });
      }
    }
  }, {
    key: '_confirmSignup',
    value: function _confirmSignup() {
      var _this5 = this;

      return this._.$ngRedux.dispatch((0, _login.confirmSignup)(this.cognito.username, this.cognito.confirmationCode)).then(function (response) {
        if (!response.payload) {
          _this5._.msgService.displayErrorMsg('Confirmation failed. Please try again. ' + (response.errors && response.errors.data && response.errors.data.message) || '');
        } else {
          _this5.signup = false;
          _this5.showConfirmation = false;
          // After successful confirmation, proceed with login
          return _this5._logIn('cognito');
        }
      }).catch(function (err) {
        _this5._.msgService.displayErrorMsg(err.message || 'Confirmation failed');
      });
    }
  }, {
    key: '_logIn',
    value: function _logIn(provider, token) {
      var _this6 = this;

      if (provider === 'cognito') {
        return this._.$ngRedux.dispatch((0, _login.loginWithCognito)(provider, this.cognito.username, this.cognito.password)).then(function (res) {
          if (!res.payload) {
            if (res.errors.data.message === 'UserNotConfirmedException') {
              _this6.showConfirmation = true;
              _this6.signup = true;
              return _this6._.$q.reject(res);
            } else {
              _this6._.msgService.displayErrorMsg('Login failed. ' + (res.errors && res.errors.data && res.errors.data.message || 'Please check your username and password and try again or sign up, if not already.'));
            }
          } else {
            return _this6._.fSession._login(res.payload);
          }
        }).catch(function (err) {
          var lnameErrorMessage = 'iFeis requires a first and last name for Google login, for more information <a href="https://ifeis.ladesk.com/863312-Google-Login-Failure">click here</a>';
          if (err && err.data && err.data.errorCode === 'last_name_missing') {
            _this6._.msgService.displayErrorMsg(lnameErrorMessage);
          }
        });
      } else {
        return this._.$ngRedux.dispatch((0, _login.login)(provider, token)).then(function (res) {
          if (!res.payload) {
            _this6._.msgService.displayErrorMsg('Login failed. Please check your username and password.');
          } else {
            _this6._.fSession._login(res.payload);
          }
        }).catch(function (err) {
          var lnameErrorMessage = 'iFeis requires a first and last name for Google login, for more information <a href="https://ifeis.ladesk.com/863312-Google-Login-Failure">click here</a>';
          if (err && err.data && err.data.errorCode === 'last_name_missing') {
            _this6._.msgService.displayErrorMsg(lnameErrorMessage);
          }
        });
      }
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword() {
      var _this7 = this;

      if (!this.cognito.email || !this.cognito.email.includes('@')) {
        this._.msgService.displayErrorMsg('Please enter a valid email address.');
      } else {
        return this._.$ngRedux.dispatch((0, _login.initiatePasswordResetWithCognito)(this.cognito.email)).then(function (response) {
          if (!response.payload) {
            if (response.errors && response.errors.data && response.errors.data.message) {
              _this7._.msgService.displayErrorMsg(response.errors.data.message);
            } else {
              _this7._.msgService.displayErrorMsg('Failed to send reset code. Please try again.');
            }
          } else {
            _this7.showResetCode = true;
            _this7._.msgService.displaySuccessMsg('Reset code sent to your email.');
          }
        }).catch(function (err) {
          _this7._.msgService.displayErrorMsg(err.message || 'Failed to send reset code');
        });
      }
    }
  }, {
    key: 'setLoginState',
    value: function setLoginState() {
      if (this.signup) {
        this.signup = !this.signup;
      }
      this.showResetPassword = false;
      this.showResetCode = false;
    }
  }, {
    key: 'confirmPassword',
    value: function confirmPassword() {
      var _this8 = this;

      return this._.$ngRedux.dispatch((0, _login.confirmPasswordResetWithCognito)(this.cognito.email, this.cognito.resetCode, this.cognito.newPassword)).then(function (response) {
        if (!response.payload) {
          _this8._.msgService.displayErrorMsg('Password reset failed. Please try again.');
        } else {
          _this8.cognito.resetCode = '';
          _this8.cognito.newPassword = '';
          _this8.showResetPassword = false;
          _this8.showResetCode = false;
          _this8._.msgService.displaySuccessMsg('Password reset successful. Please login with the new password.');
        }
      }).catch(function (err) {
        _this8._.msgService.displayErrorMsg(err.message || 'Password reset failed');
      });
    }
  }]);

  return LoginController;
}();

exports.default = angular.module('ifeis.routes.login', ['ui.router']).config(function ($stateProvider, $httpProvider) {
  $stateProvider.state('login', {
    url: '/login?provider&token&email',
    controller: 'LoginController',
    controllerAs: 'login',
    template: require('./tpl.html'),
    onEnter: function onEnter($stateParams, fSession, msgService, $ngRedux) {
      $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (response) {
        if (response.payload && response.payload.flags.isCrossNavigationEnabled) {
          var url = IFEIS_APPV2_URI + '/login';
          window.location.href = url;
        } else {
          if ($stateParams.token && $stateParams.provider) {
            console.log("logging in", $stateParams);
            fSession._login($stateParams);
          }
          // For backdoor login
          if ($stateParams.provider === 'backdoor' && $stateParams.email) {
            return $ngRedux.dispatch((0, _login.backdoorLogin)($stateParams.email)).then(function (res) {
              if (!res.payload) {
                msgService.displayErrorMsg('Backdoor login failed. Please check your username and password.');
              }
              fSession._login(res.payload);
            }).catch(function (err) {
              console.log('Error logging in with backdoor', err);
            });
          }
        }
      });
    }
  });
}).controller('LoginController', LoginController);


//////////////////
// WEBPACK FOOTER
// ./routes/login/index.js
// module id = 600
// module chunks = 0